import React from 'react';
import { AlertCircle, CheckCircle, Loader2, Zap } from 'lucide-react';

/** Card "Requisitos para el envío automático" compartida por las páginas de mensajes. */
export interface Requirement {
  label: string;
  ok: boolean;
  checking?: boolean;
  actionLabel?: string;
  onAction?: () => void;
}

interface RequirementsChecklistProps {
  title?: string;
  requirements: Requirement[];
  readyMessage: string;
  pendingMessage?: string;
  className?: string;
  style?: React.CSSProperties;
}

const RequirementsChecklist: React.FC<RequirementsChecklistProps> = ({
  title = 'Requisitos para el envío automático',
  requirements,
  readyMessage,
  pendingMessage = 'Completa los requisitos para activar el envío automático',
  className = '',
  style,
}) => {
  const allOk = requirements.every((r) => r.ok);
  return (
    <div className={`bg-surface shadow rounded-lg p-4 sm:p-6 ${className}`} style={style}>
      <h3 className="text-sm font-medium text-content mb-3">{title}</h3>
      <div className="space-y-3">
        {requirements.map((req, i) => (
          <div key={i} className="flex items-center justify-between">
            <div className="flex items-center">
              {req.checking ? (
                <Loader2 className="h-4 w-4 text-content-3 animate-spin mr-2" />
              ) : req.ok ? (
                <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
              ) : (
                <AlertCircle className="h-4 w-4 text-content-3 mr-2" />
              )}
              <span className={`text-sm ${req.ok ? 'text-content-2' : 'text-content-3'}`}>
                {req.label}
              </span>
            </div>
            {!req.ok && !req.checking && req.actionLabel && req.onAction && (
              <button
                onClick={req.onAction}
                className="text-xs text-accent hover:opacity-80 font-medium"
              >
                {req.actionLabel} →
              </button>
            )}
          </div>
        ))}
      </div>

      <div
        className={`mt-4 pt-3 border-t border-line flex items-center ${
          allOk ? 'text-green-600 dark:text-green-400' : 'text-content-3'
        }`}
      >
        <Zap className="h-4 w-4 mr-2" />
        <span className="text-sm font-medium">{allOk ? readyMessage : pendingMessage}</span>
      </div>
    </div>
  );
};

export default RequirementsChecklist;
